import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';

const BankAccountNotSupported = ({ closeModal, confirmAction = closeModal }: ModalProps) => {
  const { t } = useTranslation(['Modal', 'Common']);

  return (
    <Modal title={t('BankAccountNotSupported.title')}>
      <p>{t('BankAccountNotSupported.info')}</p>
      <ModalActions>
        <Button onClick={confirmAction}>{t('Common:ok')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default BankAccountNotSupported;
